export function initBlockLogoSlider() {
    [...document.querySelectorAll(".b-logo-slider")].forEach((el) => {
        new LogoSlider(el);
    });
}

export class LogoSlider {
    constructor(el) {
        if (!el) return;
        this.slider = el;
        this.track = el.querySelector('.b-logo-slider__row ul');
        this.items = Array.from(this.track.children);
        this.animationDuration = 20; // seconds

        this.init();
    }

    init() {
        if (this.items.length === 0) return;

        // Reset track
        this.track.innerHTML = '';

        // Append original items
        this.items.forEach(item => this.track.appendChild(item));

        requestAnimationFrame(() => {
            this.setupInfiniteScroll();
        });
    }

    setupInfiniteScroll() {
        const originalWidth = this.calculateTotalWidth();

        // Clone items to create infinite scroll effect
        this.cloneTrack(originalWidth);

        // Add hover pause functionality
        this.addHoverEffect();
    }

    calculateTotalWidth() {
        return this.items.reduce((total, item) => {
            const itemWidth = item.getBoundingClientRect().width;
            const style = window.getComputedStyle(item);
            const gap = parseFloat(style.marginRight) || 0;
            return total + itemWidth + gap;
        }, 0);
    }

    cloneTrack(originalWidth) {
        if (originalWidth <= 0) return;

        const sliderWidth = this.slider.getBoundingClientRect().width;

        // Clone items to fill at least twice the slider width
        let clonedWidth = 0;
        while (clonedWidth < sliderWidth * 2) {
            this.items.forEach(item => {
                const clone = item.cloneNode(true);
                this.track.appendChild(clone);
            });

            clonedWidth += originalWidth;
        }

        // Set up animation
        this.setupContinuousAnimation(originalWidth);
    }

    setupContinuousAnimation() {
        const speedPerSecond = 200; // Fixed speed (adjustable)

        // Calculate total width of all logos (cloned included)
        const totalWidth = this.track.scrollWidth;

        // Calculate duration dynamically to keep the speed constant
        const duration = totalWidth / speedPerSecond;

        // Apply the animation duration dynamically
        this.track.style.setProperty('--animation-duration', `${duration}s`);
        this.track.style.animation = `slide var(--animation-duration) linear infinite`;
    }


    addHoverEffect() {
        this.slider.addEventListener('mouseenter', () => {
            this.track.style.animationPlayState = 'paused';
        });

        this.slider.addEventListener('mouseleave', () => {
            this.track.style.animationPlayState = 'running';
        });
    }
}